import React from 'react'

import { vsprintf } from 'sprintf-js'

import { i18n, useLogger } from '@thg-commerce/enterprise-core'

import { ProductGrid } from '@thg-commerce/enterprise-widget-product-grid'
import { ProductGridProductProps } from '@thg-commerce/enterprise-widget-product-grid/src/ProductGrid'

import { ArticleContext } from '../../components'

export interface ProductGridRendererProps {
  isAmp: boolean
  items: {
    sku: string
    description: string
  }[]
}

export const ProductGridRenderer = (props: ProductGridRendererProps) => {
  const logger = useLogger()

  if (!props.items) {
    logger.error('Product Grid Renderer was invoked with no widget data.')
    return null
  }

  const buyAriaLabel = i18n('general.productbuynow.label')
  const buyText = i18n('general.productbuynow.text')
  const quickBuyText = i18n('general.product.quickbuy.text')
  const ArticleCtx = React.useContext(ArticleContext)
  const productListData: ProductGridProductProps[] = []

  props.items.forEach((item) => {
    const product = ArticleCtx.products.get(item.sku)
    if (product) {
      const price = product.price || { displayValue: '' }
      const title = product.title

      let productDescription = item.description
      if (!productDescription) {
        const richValueContent = product?.content?.find(
          ({ key }) => key === 'synopsis',
        )?.value?.value?.[0]

        productDescription = (richValueContent?.content?.[0]?.content ??
          '') as string
      }
      productListData.push({
        title,
        sku: item.sku,
        url: product.url,
        image: product.images?.[0].largeProduct && {
          urls: {
            largeProduct: product.images[0].largeProduct,
          },
          lazy: true,
        },
        price: product.price ? price.displayValue : '',
        button: {
          title: buyText,
          ariaLabel: vsprintf(buyAriaLabel, [title]),
          quickBuyTitle: quickBuyText,
        },
        description: productDescription,
      })
    }
  })
  return <ProductGrid isAmp={props.isAmp} products={productListData} />
}
